export default __webpack_public_path__ + "static/media/default_section_icon.ffa31fbc.svg";